import React, { useState } from 'react'
import ProductTile from "../product-tiles/ProductTile.jsx"
import { getRebuyUpsells } from '../../utils/Rebuy.js'
import { getProductsInfo } from '../../utils/Storefront.js'
import { addItemsToCart } from '../../utils/Cart.js'

class RebuyBundle extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      data: props.props,
      products: [],
      discounted: 0,
      total: 0,
      component: React.createRef(),
    }
    this.updateBundlePrices.bind(this)
    this.initProducts()
  }

  initProducts() {
    if (typeof this.state.data.sourceId != 'undefined' && this.state.data.sourceId && this.state.data.widgetId) {
      getRebuyUpsells((items) => {
        let shopifyIds = [`"gid://shopify/Product/${this.state.data.productId}"`]
        items.forEach((item, index) => shopifyIds.push(`"gid://shopify/Product/${item.id}"`))
        
        getProductsInfo((products) => {
          let tempProducts = products.filter(product => product.availableForSale).slice(0, this.state.data.limit)
          
          tempProducts.forEach((product) => {
            product.rebuyWidgetId = this.state.data.widgetId
            product.collectionBadges = product.collections.edges.map((edge) => edge.node.tile_message ? edge.node.tile_message.value : null )
            product.updateBundlePrices = this.updateBundlePrices
            product.pairingOption = JSON.parse(product.pairingOption?.value || '[]')
          })
          this.setState({ products: tempProducts })
          setTimeout(() => {
            this.updateBundlePrices()
          }, 300)
        }, shopifyIds.join(','))
      }, this.state.data.sourceId, this.state.data.productId)
    }
  }

  updateBundlePrices = () => {
    let total = 0
    this.state.component.current.querySelectorAll('.card-wrapper').forEach((tile) => {
      const variantState = JSON.parse(tile.dataset.state)
      total += parseFloat(variantState.selectedVariant.price.amount) * variantState.multiply
    })

    this.setState({ total: total, discounted: total * ( 100 - this.state.data.percent ) / 100.0 })
  }

  addBundle() {
    let items = []
    this.state.component.current.querySelectorAll('.card-wrapper').forEach((tile) => {
      const variantState = JSON.parse(tile.dataset.state)
      items.push({ 
        id: variantState.selectedVariant.id.replace('gid://shopify/ProductVariant/', ''), 
        quantity: variantState.multiply, 
        properties: Object.assign(variantState.cartProperties, variantState.selectedVariant.compareAtPrice && parseFloat(variantState.selectedVariant.compareAtPrice.amount) > parseFloat(variantState.selectedVariant.price.amount) ? {'Compare Price': `$${variantState.selectedVariant.compareAtPrice.amount}`} : {}) 
      })
    })    
    addItemsToCart( items )
  }

  render() {
    return (
      <div className={`${this.state.products.length > 1 ? '' : 'hidden'}`} ref={this.state.component}>
        { this.state.data.title && <h2 className="px-8 text-center text-[2.4rem] lg:text-[3.4rem]" dangerouslySetInnerHTML={{ __html: this.state.data.title }} style={ {marginBottom: '1.8rem'} } /> }
        { this.state.products.length > 1 &&
          <div className="overflow-auto">
            <div className={`container lg:mx-auto flex w-max lg:w-full lg:grid gap-10 lg:max-w-[initial] 2xl:max-w-[153.6rem] lg:grid-cols-${this.state.products.length}`}>
              {
                this.state.products.map((product, index) =>
                  <ProductTile key={`rebuy-bundle-${this.state.data.productId}-${this.state.data.widgetId}-${product.id}-${index}`}
                    updateBundlePrices={this.updateBundlePrices}
                    props={product} />
                )
              }
            </div>
          </div> 
        }
        
        <div className="text-center mt-8">
          <div className="mb-8 flex items-center justify-center gap-4">
            <span className="font-bold">Total Price:</span>
            <span className="line-through">
              ${parseFloat(this.state.total).toFixed(2)}
            </span>
            <span className="text-sale">
              ${parseFloat(this.state.discounted).toFixed(2)}
            </span>
          </div>
          <button className="button button--primary button--rounded" onClick={(e) => this.addBundle()}>Add Bundle to Cart</button>
        </div>
      </div>
    )
  }
}

export default RebuyBundle